module.exports = __webpack_public_path__ + "img/shucun_2.5a06be50.png";